<template>
    <div
        class="g search"
        :class="[ctrlDisplayToolBar? 'is-open':'']"
        v-if="searchItem.length > 0 || setTitle || download"
    >
        <div
            class="md toggle-extend"
            :class="[ctrlDisplayToolBar? 'is-active':'']"
        >
            <a @click.prevent.stop="toggleCtrlDisplayToolBar" title="展開/收合"></a>
        </div>
        <mdSearch
            v-if="ctrlDisplayToolBar"
        >
            <cpSearch
                class="search"
                v-for="item in searchItem"
                :obj="item"
                :searchCondition="ctrlSearchCondition[item.prop]"
                :key="item.prop"
                @sendEvent="receiveEvent"
            ></cpSearch>
            <!-- <cpBtn
                v-if="searchItem.length > 0"
                icon="find_in_page"
                themes="expert"
                text="篩選"
                @click.prevent="doSearch"
            ></cpBtn>
            <cpBtn
                v-if="searchItem.length > 0"
                icon="replay"
                themes="info"
                text="重設"
                @click.prevent="reSearch"
            ></cpBtn><cpBtn
                v-if="setTitle"
                icon="brush"
                themes="info"
                text="調整"
                @click.prevent="setTableTitle"
            ></cpBtn><cpBtn
                v-if="download"
                themes="info"
                icon="cloud_download"
                text="下載"
                @click.prevent="downloadTable"
            ></cpBtn> -->
            
            <template v-if="btns.length > 0"><cpBtn
                v-for="item in btns"
                :key="JSON.stringify(item)"
                v-bind="item"
                @sendEvent="receiveEvent"
            ></cpBtn></template>
            <slot></slot>
        </mdSearch>
        <mdSearch
            v-else-if="realSearchInfoExport"
            v-html="realSearchInfoExport"
        ></mdSearch>

    </div>
</template>

<script>
    import cpSearch from '@/components/cpSearch'
    import mdSearch from '@/components/mdSearch'
    import mdBtnList from '@/components/mdBtnList'
    import cpBtn from '@/components/cpBtn'

    export default {
        components: {
            cpSearch,
            mdSearch,
            mdBtnList,
            cpBtn
        },
        props: {
            title: {
                type: Array,
                require: true
            },
            content: {
                type: Array,
                require: true
            },
            setTitle: { //是否讓使用者自選要顯示的欄位
                type: Boolean,
                require: true
            },
            ctrlDisplayToolBar: {
                type: Boolean,
                require: true
            },
            download: {
                type: Boolean,
                require: true
            },
            ctrlSearchCondition: {
                type: Object,
                require: true
            },
            realSearchInfoExport: {
                type: String,
                require: true
            },
            searchBtnList: { //擴增按鈕功能
                type: Array,
                required: false,
                default: function(){
                    return [];
                }
            }
        },
        computed: {
            searchItem: function(){
                let $search = [];

                let $title = this.title,
                    $content = this.content;

                $title.forEach(item => {

                    if( item.searchable && item.showtype !== 'boolean' ) {
                        let $obj = {
                                caption: item.caption,
                                prop: item.prop,
                                inputtype: item.inputtype,
                                value: '',
                                options: []
                            }

                        let _prop = item.prop;

                        $content.forEach(data => {

                            let _value = this.$okaTool.htmlFilter(data[_prop]);

                            if( _value !== '' && _value !== null ) {
                                let $target = $obj.options.find(item => {
                                        return item.value === _value;
                                    });

                                if( $target ) {

                                    if( data.show ) { 
                                        $target.length += 1;
                                    }
                                }else {

                                    let _length = 0;

                                    if( data.show ) { 
                                        _length = 1;
                                    }

                                    $obj.options.push({
                                        value: _value,
                                        length: _length
                                    });
                                }
                            }
                        });

                        let $_convertType = (val) => {

                                if( val == parseFloat(val, 10) ) {
                                    return parseFloat(val, 10);
                                }else if( typeof val === 'string' ){
                                    return val.toLowerCase();
                                }else if( val.value ){
                                    return $_convertType(val.value);
                                }else {
                                    return val;
                                }
                            }

                        $obj.options.sort((a, b) => {
                            let _this = $_convertType(a),
                                _that = $_convertType(b);

                            if( _this > _that ) {
                                return 1;
                            }else {
                                return -1;
                            }
                        });

                        if( $obj.options.length ) {
                            $search.push($obj);
                        }
                    }
                });

                return $search;
            },
            btns: function(){

                let $search= {
                        themes: 'expert',
                        icon: 'find_in_page',
                        text: '篩選',
                        func: 'doSearch',
                    },
                    $reSearch= {
                        themes: 'expert',
                        icon: 'find_in_page',
                        text: '重設',
                        func: 'reSearch',
                    },
                    $setTableTitle= {
                        themes: 'info',
                        icon: 'brush',
                        text: '調整',
                        func: 'setTableTitle',
                    },
                    $downloadTable= {
                        themes: 'info',
                        icon: 'cloud_download',
                        text: '下載',
                        func: 'downloadTable',
                    },
                    $result =[];

                
                    if(this.searchItem.length > 0){
                        $result.push($search)
                        $result.push($reSearch)
                    }
                    if(this.setTitle){
                        $result.push($setTableTitle)
                    }
                    if(this.download){
                        $result.push($downloadTable)
                    }
                    if(this.searchBtnList.length > 0){
                        this.searchBtnList.forEach(item =>{
                            $result.push({
                                themes: item.themes,
                                icon: item.icon,
                                text: item.text,
                                func: item.func,
                            })
                        })
                    }

                return $result;
            }
        },
        methods: {
            toggleCtrlDisplayToolBar: function(){
                this.$emit('sendEvent', 'toggleCtrlDisplayToolBar');
            },
            setTabValue: function(prop, value){
                this.$emit('sendEvent', 'setTabValue', prop,value);
            },
            setTableTitle: function(){
                this.$emit('sendEvent', 'setTableTitle');
            },
            downloadTable: function(){
                this.$emit('sendEvent', 'downloadTable');
            },
            doSearch: function(){
                this.$emit('sendEvent', 'doSearch');
            },
            reSearch: function(){
                this.$emit('sendEvent', 'reSearch');
            }
        }
    }
</script>

<style scoped lang="scss">

    .g.search {
        position: relative;

        &::v-deep {

            + .md.major-table {
                margin-top: 0 !important;
            }
        }

        &.is-open {

            &::v-deep {

                + .md.major-table {
                    margin-top: $interval-m !important;
                }
            }
        }

        .g.popup-table & {

            &.is-open {
                margin-top: 16px;
            }
        }
    }

    .md.toggle-extend {
        $size: 20px;

        position: absolute;
        right: 0;
        top: 0;
        z-index: 2;

        &.is-active {

            a {

                &::after {
                    content: '\e5c7';
                }
            }
        }

        a {
            display: block;
            position: relative;
            width: $size;
            height: $size;
            margin-top: -1 * $interval-s;
            margin-right: -1 * $interval-s;
            color: $white;
            cursor: pointer;
            background-color: $deep;
            border-radius: 50%;
            background-color: $deep-gray;

            &:hover {

                &::after {
                    opacity: $opacity-m;
                }
            }

            &::after {
                @extend %font-pseudo;
                content: '\e5c5';
                text-align: center;
                position: absolute;
                width: $size;
                height: $size;
                line-height: $size;
                transition: $transition;
            }
        }

        + .md.search {
            padding: $interval-m;
            border-radius: $border-radius;
            border: $border;

            &::before {
                position: absolute;
                content: attr(data-title);
                color: $white;
                left: 0.5 * $size;
                top: -12px;
                // border-radius: $border-radius;
                padding: 0 $interval-s;
                font-size: $font-size-s;
                background-color: $deep-gray;
            }
        }
    }

    // .md.search-extend {
    //     display: flex;

    //     .md.btn-list {

    //         .g.pop-up-content + & { //popup
    //             flex-shrink: 0;
    //             padding: $interval-m $interval-xxl $interval-xl;
                
    //         }

    //         &.is-block {
    //             display: block;

    //             li {

    //                 a {
    //                     display: block;
    //                 }
    //             }
    //         }

    //         ul {
    //             @extend %reset;
    //             display: flex;

    //             @include media('mobile') {
    //                 display: block;
    //             }
    //         }

    //         li {
    //             + li {
    //                 margin-left: $interval-s;

    //                 @include media('mobile') {
    //                     margin-top: $interval-s;
    //                     margin-left: 0;
    //                 }
    //             }
    //         }

    //         a {
    //         display: inline-block; 

    //             @include media('mobile') {
    //                 display: block;
    //             }
    //         }
    //     }
    //     .search + div {
    //         margin-left: $interval-s;
    //     }
       
    // }
   
</style>
